import css from './beforePane.module.scss';
import cssPane from '../wordPane.module.scss';

import { memo } from 'react';

import KeyBind from 'core/ui/KeyBind';
import Kkb from 'core/ui/Kkb';
import LangIcon from 'core/ui/LangIcon';

const BeforePane: React.FC<{
  flip: (event: React.SyntheticEvent | Event) => Promise<void>;
  disabled: boolean;
  lang: TLang | null;
}> = ({ flip, disabled, lang }) => {
  return (
    <div
      className={`${cssPane.wordSplitPane}  ${css.beforePane}`}
      data-interactive={!disabled}
      onClick={evt => void flip(evt)}
    >
      <KeyBind kkb="Space" onKeyPress={flip} disabled={disabled} />
      <KeyBind kkb="ArrowDown" onKeyUp={flip} disabled={disabled} />
      <div className={css.startQuestion}>
        {lang && <LangIcon lang={lang} />} Ready?
      </div>
      <Kkb className={css.kkb} children="space, ↓" />
    </div>
  );
};

export default memo(BeforePane);
